import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AnimatedCard from "../../../../components/AnimatedCard/AnimatedCard";
import AuthMethods from "../../../../components/AuthMethods/AuthMethods";
import useAuthRedirect from "../../../../hooks/useAuthRedirect";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_Registration_pages_Signup_Signup";

const Signup: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  useAuthRedirect();

  return (
    <div className="flex justify-center flex-col items-center min-h-[calc(100vh-6rem)] bg-background py-8">
      <AnimatedCard title={t("title")} className="bg-white max-w-lg w-full">
        <AuthMethods mode="signup" />
        <div className="text-center mt-4">
          {t("have-account")}{" "}
          <Link to="/registration/signin" className="text-blue-600">
            {t("signin-link")}
          </Link>
        </div>
      </AnimatedCard>
    </div>
  );
};

export default withTranslations(LOCALE)(Signup);
